(function () {
  'use strict';

  angular
    .module('scorm.scormCtrl')
    .directive('scormComm', scormComm);

  scormComm.$inject = ['$window'];

  function scormComm($window) {
    return {
      scope: {
        receiveMessage: '&',
        sendMessage: '&',
        hostUrl: '@'
      },
      link: function (scope, elem) {
        var iframe = elem[0];

        var receiveMessage = function (e) {
          var data = angular.fromJson(e.data);
          scope.receiveMessage({ data: data });
        };

        var sendMessage = function (data) {
          data = angular.toJson(data);
          iframe.contentWindow.postMessage(data, scope.hostUrl);
        };

        scope.sendMessage({ cb: sendMessage });

        $window.addEventListener('message', receiveMessage, false);

        scope.$on('$destroy', function () {
          $window.removeEventListener('message', receiveMessage, false);
        });
      }
    };
  }
})();
